import PropTypes from 'prop-types';

import Heading from 'components/typography/heading';
import Text from 'components/typography/text';
import ResistCTAButtons from './buttons/cta';
import { container, step } from './springboard.module.scss';

export const Springboard = ({
  keyword = 'resist',
  message = 'Introduce yourself!',
}) => {
  const keywordUpper = keyword.toUpperCase();
  return (
    <div className={container}>
      <Heading as={'h2'} size={'h2'}>
        {message}
      </Heading>

      <Text className={step}>
        <strong>1.</strong> Tap one of these buttons. It will open up your text
        app with a prefilled text to Resistbot.
      </Text>

      <ResistCTAButtons keyword={keywordUpper} />

      <Text className={step}>
        <strong>2.</strong> Send the text.
      </Text>

      <Text className={step}>
        <strong>3.</strong> Read the texts that come back and follow the
        directions!
      </Text>
    </div>
  );
};

Springboard.propTypes = {
  keyword: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default Springboard;
